export default "__VITE_ASSET__b2ef27e2__"